import { ListItem, ListItemText, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { useUser } from "lib/user/use-user"

export function MacroConsumerItem({ consumer }) {
    const { user } = useUser(consumer?.draftCreatedBy)
    if (!consumer) return null

    const ownerLabel = resolveOwnerLabel(user)

    return (
        <ListItem divider disableGutters data-cy={`macro-consumer-item-${consumer.id}`}>
            <ListItemText
                primary={
                    <Typography variant="subtitle2" data-cy="macro-consumer-title">
                        {resolveTitle(consumer)}
                    </Typography>
                }
                secondary={
                    <Stack spacing={0.25}>
                        <If truthy={consumer.draftCode}>
                            <Typography variant="caption" color="text.secondary" data-cy="macro-consumer-code">
                                {consumer.draftCode}
                            </Typography>
                        </If>
                        <If truthy={ownerLabel}>
                            <Typography variant="caption" color="text.secondary" data-cy="macro-consumer-owner">
                                {`Created by ${ownerLabel}`}
                            </Typography>
                        </If>
                    </Stack>
                }
            />
        </ListItem>
    )
}

function resolveTitle(consumer) {
    if (consumer.draftTitle) return consumer.draftTitle
    if (consumer.draftCode) return consumer.draftCode
    return "Untitled work package"
}

function resolveOwnerLabel(user) {
    if (user?.displayName) return user.displayName
    if (user?.email) return user.email
    return ""
}
